export default "__VITE_ASSET__b8lvM8An__"